import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [headerOptions, setHeaderOptions] = useState({
    showHamburger: false,
    onHamburgerClick: null,
    sectionTitle: '',
  });

  return (
    <HeaderContext.Provider value={{ headerOptions, setHeaderOptions }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => useContext(HeaderContext); 